import { useNavigate } from "react-router-dom";
import { LogOut, Mail, User as UserIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function Profile() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div data-testid="profile-page" className="max-w-xl space-y-8">
      <div className="animate-fade-up">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">Compte</p>
        <h1 className="mt-2 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Profil</h1>
      </div>

      <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-5">
        <div className="flex items-center gap-4">
          <span className="h-14 w-14 rounded-2xl bg-blue-50 text-blue-600 grid place-items-center">
            <UserIcon className="h-6 w-6" />
          </span>
          <div>
            <p data-testid="profile-name" className="font-display text-xl font-semibold text-slate-900">{user?.name}</p>
            <p data-testid="profile-email" className="text-sm text-slate-500 flex items-center gap-1.5">
              <Mail className="h-3.5 w-3.5" /> {user?.email}
            </p>
          </div>
        </div>
        <div className="pt-5 border-t border-slate-100">
          <Button onClick={onLogout} data-testid="logout-btn"
            className="rounded-full bg-red-50 text-red-600 border border-red-200 hover:bg-red-100">
            <LogOut className="h-4 w-4 mr-1.5" /> Se déconnecter
          </Button>
        </div>
      </div>

      <p className="text-sm text-slate-500 leading-relaxed">
        Version MVP. À venir : rappels et notifications, base de périodicités constructeur,
        estimation automatique des coûts et application mobile.
      </p>
    </div>
  );
}
